import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, browserHistory } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import DateRangeIcon from '@material-ui/icons/DateRange';
import Typography from '@material-ui/core/Typography';
import { find } from 'lodash';
import moment from 'moment';
import MomentUtils from '@date-io/moment';

import { DatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';

import { addQuery } from '@lib/services/queryService';

import PatientJourneyTimeline from './PatientJourneyTimeline';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  header: {
    position: 'absolute',
    left: theme.custom.MuiDrawer.width - 5,
    zIndex: 1,
    marginTop: theme.spacing.unit * 4,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    display: 'flex',
    flexDirection: 'column',
  },
  headerLink: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: theme.spacing.unit,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  wrapperTimeline: {
    width: '100%',
    maxWidth: 800,
    padding: 0,
  },
  iconLeft: {
    marginRight: theme.spacing.unit,
    fontSize: theme.spacing.unit * 2,
  },
});

export class PatientTabJourney extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rangeBy: props.location.query.rangeBy || 'years',
    };
  }

  componentWillMount() {
    const {
      loadPatientJourney,
      patient: { _id },
    } = this.props;
    const { rangeBy } = this.state;
    loadPatientJourney(_id, rangeBy);
  }

  componentWillReceiveProps(nextProps) {
    const {
      location: { query },
    } = nextProps;
    if (query.rangeBy !== this.props.location.query.rangeBy) {
      const {
        loadPatientJourney,
        patient: { _id },
      } = this.props;
      const rangeBy = query.rangeBy || 'years';
      loadPatientJourney(_id, rangeBy);
      this.setState({
        rangeBy,
      });
    }
  }

  handleDisableDate = (value) => {
    const { journey } = this.props;
    // Disable dates if there are no events loaded yet
    if (!journey) {
      return true;
    }
    const date = moment(value);
    return !find(journey.response, (event) => (event.details ? date.isSame(event.details.date, 'day') : false));
  };

  handleDateChange = (date) => {
    addQuery({
      rangeBy: 'days',
      date: moment(date).unix(),
    });
  };

  render() {
    const {
      classes,
      patient,
      journey,
      location: {
        query: { date },
      },
      permissions,
      singleline,
    } = this.props;
    const events = journey ? journey.events : false;

    return (
      <div className={classes.root}>
        {this.renderHeader()}
        <div className={classes.wrapperTimeline}>
          <PatientJourneyTimeline
            patient={patient}
            permissions={permissions}
            events={events}
            date={date}
            singleline={singleline}
            onEventSelected={({ start }) => this.handleDateChange(start)}
          />
        </div>
      </div>
    );
  }

  renderHeader = () => {
    const { classes, patient } = this.props;
    const { rangeBy } = this.state;
    const showBackLink = rangeBy !== 'years';

    return (
      <Paper className={classes.header}>
        {showBackLink && (
          <Typography
            component="a"
            className={classes.headerLink}
            onClick={() => browserHistory.push(`/patients/${patient._id}/journey`)}
          >
            <KeyboardArrowLeftIcon className={classes.iconLeft} />
            Back
          </Typography>
        )}
        <div>{this.renderDatePicker()}</div>
      </Paper>
    );
  };

  renderDatePicker = () => {
    const { classes, singleline } = this.props;

    if (singleline) return null;

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <DatePicker
          ref={(ref) => {
            this.dateRef = ref;
          }}
          data-lh-id="date-picker-patient-journey"
          style={{ display: 'none' }}
          format="L"
          animateYearScrolling={false}
          name="date"
          autoOk
          firstDayOfWeek={0}
          shouldDisableDate={this.handleDisableDate}
          onChange={(newValue) => this.handleDateChange(newValue)}
        />
        <Typography component="a" className={classes.headerLink} onClick={() => this.dateRef.open()}>
          <DateRangeIcon className={classes.iconLeft} />
          Jump to date
        </Typography>
      </MuiPickersUtilsProvider>
    );
  };
}

PatientTabJourney.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  patient: PropTypes.object.isRequired,
  journey: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.bool]),
  loadPatientJourney: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
  singleline: PropTypes.bool,
};

export default withRouter(withStyles(styles)(PatientTabJourney));
